// Zweck: Kompakte Artikelkarte ohne Buchungslogik. Stand: 22.10.2026.
import type { SimState } from '../interfaces/deviceSimulation';
import type { WarehouseHeroAction } from '../interfaces/warehouseHero';
import WarehouseArticleDetails from './WarehouseArticleDetails';
import WarehouseHeroStatus from './WarehouseHeroStatus';
import { WarehouseIcon } from './WarehousePresentation';

export default function WarehouseStockArticleCard({
  article: a,
  stocks,
  locationName,
  status,
  syncHero,
  disabled,
  onDevices,
}: {
  article: SimState['articles'][number];
  stocks: SimState['stocks'];
  locationName(id: string): string;
  status?: string;
  syncHero?: WarehouseHeroAction;
  disabled: boolean;
  onDevices(): void;
}) {
  return (
    <article className="wh-line wh-stock-card">
      <strong>{a.name}</strong>
      <p className="wh-field-hint">Artikelnr. {a.number}</p>
      {syncHero && (
        <WarehouseHeroStatus
          articleId={a.id}
          unit={a.unit}
          status={status}
          disabled={disabled}
          run={syncHero}
        />
      )}
      <dl className="wh-stock-amounts">
        {stocks.map((stock) => (
          <div key={stock.locationId}>
            <dt>
              <WarehouseIcon kind="location" /> {locationName(stock.locationId)}
            </dt>
            <dd>
              {stock.quantity.toLocaleString('de-DE', {
                maximumFractionDigits: 3,
              })}{' '}
              {a.unit}
            </dd>
          </div>
        ))}
      </dl>
      <WarehouseArticleDetails
        unit={a.unit}
        codes={a.codes}
        tracked={a.tracked}
      >
        {a.tracked && (
          <button onClick={onDevices}>
            <WarehouseIcon kind="stock" /> Geräte zu diesem Artikel anzeigen
          </button>
        )}
      </WarehouseArticleDetails>
    </article>
  );
}
